import React, { useMemo } from "react";

import { PageHeader } from "../../PageHeader";

import { AddScheduledJobButton } from "./AddScheduledJobButton";
import { ScheduledJobsTable } from "./ScheduledJobsTable";
import { useLoadScheduledJobs } from "./useLoad";
import {
    SCHEDULED_UNIQUE_JOB_TYPES,
    SCHEDULED_REUSABLE_JOB_TYPES,
    ScheduledJobType,
} from "../../../enums/ScheduledJobType";

export function ScheduledJobsPage() {
    const { jobs, setJobs, loading, load } = useLoadScheduledJobs();

    const availableJobTypes: ScheduledJobType[] = useMemo(() => (
        SCHEDULED_UNIQUE_JOB_TYPES
            .filter(type => !jobs.map(job => job.type).includes(type))
            .concat(SCHEDULED_REUSABLE_JOB_TYPES)
    ), [jobs]);

    return (
        <>
            <PageHeader isLoading={loading}>
                Scheduled Jobs
            </PageHeader>

            <AddScheduledJobButton
                onJobAdded={(job) => setJobs([...jobs, job])}
                availableJobTypes={availableJobTypes}
            />

            <ScheduledJobsTable
                jobs={jobs}
                setJobs={setJobs}
                loadJobs={load}
                availableJobTypes={availableJobTypes}
                isLoading={loading}
            />
        </>
    );
}
